import { useShowCountingQuery } from "@/services/backend/countings/service";
import { BatchAssignmentDialog } from "@/shared/components/domain/samples/batch-assignment-dialog";
import { ErrorAssignmentDialog } from "@/shared/components/domain/samples/error-assignment-dialog";
import { SampleTable } from "@/shared/components/domain/samples/sample-table";
import { ReactElement } from "react";
import { useParams } from "react-router";

export function SampleOverviewIndexRoute(): ReactElement {
  const { countingId } = useParams();
  const { data: counting } = useShowCountingQuery({ id: countingId! });
  const immutable = !!counting?.counting.immutable;

  return (
    <div className="flex flex-col space-y-4">
      <div className="flex w-96 flex-row space-x-2">
        {!immutable && (
          <>
            <BatchAssignmentDialog
              ownerType="counting.Counting"
              ownerId={countingId!}
            />
            <ErrorAssignmentDialog
              ownerType="counting.Counting"
              ownerId={countingId!}
            />
          </>
        )}
      </div>
      <SampleTable ownerId={countingId!} ownerType="counting.Counting" />
    </div>
  );
}
